import React from "react";
import RedirectToLive from "../containers/RedirectToLive";

const PointsRaceStartList = (props) => {
  const {
    EventName,
    RailingList,
    BluebandList,
    ExecuteUpdate,
  } = props;

  const contentRailing = RailingList.map((pointsRace, i) =>
    <tr className="d-flex" key={i}>
      <td className="col-md-3">{pointsRace.Bib}</td>
      <td className="col-md-6">{pointsRace.Name}</td>
      <td className="col-md-3">
        <img
          src={process.env.PUBLIC_URL + '/Flags/' + pointsRace.Nat + '.bmp'}
          height="25"
          width="60"
          alt={pointsRace.Nat}
        />
      </td>
    </tr>
  );

  const contentBlueband = BluebandList.map((pointsRace, i) =>
    <tr className="d-flex" key={i}>
      <td className="col-md-3">{pointsRace.Bib}</td>
      <td className="col-md-6">{pointsRace.Name}</td>
      <td className="col-md-3">
        <img
          src={process.env.PUBLIC_URL + '/Flags/' + pointsRace.Nat + '.bmp'}
          height="25"
          width="60"
          alt={pointsRace.Nat}
        />
      </td>
    </tr>
  );

  return (
    <div className="container">
      <RedirectToLive Update={ExecuteUpdate} />
      <h2>{EventName} StartList </h2>
      <br />
      <br />
      <br />
      <h3 className="text-center">Starting on the Railing</h3>
      <table className="table">
        <thead>
          <tr className="d-flex">
            <th className="col-md-3">Bib</th>
            <th className="col-md-6">Name</th>
            <th className="col-md-3">Team</th>
          </tr>
        </thead>
        <tbody>
          {contentRailing}
        </tbody>
      </table>
      <br />
      <br />
      <br />
      <h3 className="text-center">Starting on the Blueband</h3>
      <table className="table">
        <thead>
          <tr className="d-flex">
            <th className="col-md-3">Bib</th>
            <th className="col-md-6">Name</th>
            <th className="col-md-3">Team</th>
          </tr>
        </thead>
        <tbody>
          {contentBlueband}
        </tbody>
      </table>
      <br />
      <br />
      <br />
    </div>
  );
};

export default PointsRaceStartList;  